export default __webpack_public_path__ + "static/media/Advanced Potion Making - BasedOn-09_00.47dae92e.jpg";